import React from "react";
import { TextField } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { Text } from "$components";
import CField from "$forms/CField";
import { useDockyardFormContext } from "../context/DockyardFormContext";

export const NotesSection: React.FC = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const { canEdit } = useDockyardFormContext();

  return (
    <>
      <div className="bordered">
        <Text type="h3">Notes</Text>
      </div>
      <div>
        <CField
          control={control}
          disabled={!canEdit}
          name="notes"
          error={errors.notes}
        >
          {(props) => (
            <TextField
              {...props}
              variant="outlined"
              style={{ width: "100%" }}
              multiline
            />
          )}
        </CField>
      </div>
      <div style={{ height: 20 }} />
    </>
  );
};
